<template>
  <PageHeader :isTransparent="false"/>
  <div class="detail-container">
    <div class="main-content">
      <!-- 左侧视频播放区域 -->
      <div class="video-section">
        <div class="video-player">
          <video 
            :src="currentGame.videoUrl" 
            controls 
            class="main-video"
            poster="/images/games/thumbnails/video-cover.jpg"
          >
            您的浏览器不支持 video 标签
          </video>
        </div>
        <div class="video-info">
          <h1>{{ currentGame.title }}</h1>
          <div class="meta-info">
            <span class="views">{{ currentGame.viewsNumber || 99 }}观看次数 | {{ currentGame.videoMinute }}分钟</span>
<!--            <span class="platform">-->
<!--              <img :src="currentGame.platformIcon" :alt="currentGame.platform">-->
<!--              {{ currentGame.platform }}-->
<!--            </span>-->
          </div>
          <div class="game-description">
            {{ currentGame.description }}
          </div>
        </div>
      </div>

      <!-- 右侧推荐视频列表 -->
      <div class="recommended-section">
        <h2>推荐视频</h2>
        <div class="recommended-list">
          <div 
            v-for="game in recommendedGames" 
            :key="game.id"
            class="recommended-item"
            @click="goToDetail(game.id)"
          >
            <div class="thumb">
              <img :src="game.imageUrl" :alt="game.title">
              <span class="duration">{{ game.createdTime }}</span>
            </div>
            <div class="info">
              <h3>{{ game.title }}</h3>
              <p>{{ game.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <FooterComponent/>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import PageHeader from "@/components/PageHeader.vue"
import FooterComponent from "@/components/FooterComponent.vue"
import { noPermissionList, noPermission } from '@/api/memberStyle'

const route = useRoute()
const router = useRouter()

const currentGame = ref({})

const recommendedGames = ref([])

//查询后端获取详细数据
const fetchGameDetail = async () => {
  const gameId = route.params.id
  noPermission(gameId)
      .then(res => {
        if (res.code === 200) {
          currentGame.value = res.data
        }
      })
}

//查询后端获取列表数据
const fetchGameList = async () => {
  noPermissionList({pageNum:1,pageSize:5,status:20})
      .then(res => {
        if (res.code === 200) {
          recommendedGames.value = res.rows
        }
      })
}

const goToDetail = (gameId) => {
  router.push(`/membership/detail/${gameId}`)
}

// 监听路由参数变化
watch(() => route.params.id, () => {
  fetchGameDetail()
})

// 组件挂载时获取数据
onMounted(() => {
  fetchGameDetail();
  fetchGameList();
})
</script>

<style scoped>
.detail-container {
  max-width: 1440px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f7f7f7;
}

.main-content {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 24px;
}

.video-section {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
}

.video-player {
  width: 100%;
  position: relative;
  padding-top: 56.25%; /* 16:9 比例 */
}

.main-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.video-info {
  padding: 20px;
}

.video-info h1 {
  font-size: 24px;
  margin-bottom: 12px;
}

.meta-info {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
  color: #666;
}

.platform {
  display: flex;
  align-items: center;
  gap: 8px;
}

.platform img {
  width: 20px;
  height: 20px;
}

.game-description {
  color: #333;
  line-height: 1.6;
}

.recommended-section {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
}

.recommended-section h2 {
  margin-bottom: 16px;
  font-size: 20px;
}

.recommended-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.recommended-item {
  display: flex;
  gap: 12px;
  cursor: pointer;
  transition: transform 0.2s;
}

.recommended-item:hover {
  transform: translateX(5px);
}

.thumb {
  position: relative;
  width: 168px;
  height: 94px;
}

.thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

.duration {
  position: absolute;
  bottom: 4px;
  right: 4px;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  padding: 2px 4px;
  border-radius: 4px;
  font-size: 12px;
}

.info {
  flex: 1;
}

.info h3 {
  font-size: 14px;
  margin-bottom: 4px;
}

.info p {
  font-size: 12px;
  color: #666;
}

/* 响应式布局 */
@media screen and (max-width: 1024px) {
  .main-content {
    grid-template-columns: 1fr;
  }
  
  .recommended-section {
    margin-top: 20px;
  }
  
  .recommended-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 16px;
  }
}

@media screen and (max-width: 768px) {
  .detail-container {
    padding: 10px;
  }
  
  .video-info h1 {
    font-size: 20px;
  }
  
  .recommended-list {
    grid-template-columns: 1fr;
  }
}

@media screen and (max-width: 480px) {
  .recommended-item {
    flex-direction: column;
  }
  
  .thumb {
    width: 100%;
    height: 200px;
  }
}
</style> 